<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Ítems</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button @click="exportar" type="button" class="btn-success">
            <i class="fa fa-file-excel-o"></i>
            <span>Exportar</span>
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="form-inline">
          <label v-show="tipo === 'T'" for="proveedores">
            <input
              @change="$refs.listaItems.loadRows()"
              type="checkbox"
              id="proveedores"
              v-model="params.proveedores"
            />
            <span>Mostrar items de proveedores</span>
          </label>
          <label v-show="tipoProducto === 'T'" for="tItems">
            <input
              @change="$refs.listaItems.loadRows()"
              v-model="params.tipoItem"
              type="radio"
              id="tItems"
              value="T"
            />
            <span>Todos los ítems</span>
          </label>
          <label v-show="tipoProducto === 'T'" for="productos">
            <input
              @change="$refs.listaItems.loadRows()"
              v-model="params.tipoItem"
              type="radio"
              id="productos"
              value="P"
            />
            <span>Productos</span>
          </label>
          <label v-show="tipoProducto === 'T'" for="servicios">
            <input
              @change="$refs.listaItems.loadRows()"
              v-model="params.tipoItem"
              type="radio"
              id="servicios"
              value="S"
            />
            <span>Servicios</span>
          </label>
        </div>
      </div>
    </div>
    <k-table
      :params="params"
      :filterStatus="filterStatus"
      @crear="crear"
      :createButton="createButton"
      :editButton="false"
      :deleteButton="false"
      ref="listaItems"
      @seleccionar="seleccionar"
      :path="url + '/items/search'"
      :columns="[
            {
                display : 'Código',
                value : 'codigo'
            },
            {
                display : 'Tipo',
                value : 'descripcion_tipo_item'
            },
            {
                display : 'Tipo de item',
                value : 'descripcion_tipo'
            },
            {
                display : 'Categoría',
                value : 'descripcion_categoria'
            },
            {
                display : 'Nombre',
                value : 'nombre'
            },
            {
                display : 'Descripción',
                value : 'descripcion'
            },
            {
                display : 'Marca',
                value : 'descripcion_marca'
            },
            {
                display : 'Precio de venta',
                value : 'precio_venta'
            },
            {
                display : 'Subsidio',
                value : 'valor_subsidio'
            },
            {
                display : 'IVA',
                value : 'iva'
            },
            {
                display : 'ICE',
                value : 'ice'
            },
            {
                display : 'IRBPNR',
                value : 'descripcion_irbpnr'
            }
        ]"
    ></k-table>
    <modal :width="'80%'" height="auto" :scrollable="true" name="item">
      <item
        :tipoProducto="tipoProducto"
        :tipo="tipo"
        @saved="createdItem"
        :searchButton="searchButton"
        @created="createdItem"
      ></item>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    createButton: {
      type: Boolean,
      required: false,
      default: true
    },
    filterStatus: {
      type: Boolean,
      required: false,
      default: true
    },
    searchButton: {
      type: Boolean,
      required: false,
      default: false
    },
    tipo: {
      type: String,
      required: false,
      default: "T"
    },
    tipoProducto: {
      type: String,
      required: false,
      default: "T"
    }
  },
  data: function() {
    return {
      currentIndex: -1,
      currentItem: null,
      url: url,
      params: {
        tipo: this.tipo,
        tipoItem: this.tipoProducto,
        proveedores: this.tipo === "P"
      }
    };
  },
  methods: {
    exportar: function() {
      let form = this.$refs.listaItems.form;
      window.open(
        url +
          "/items/search?exportar=S&status=" +
          form.status +
          "&tipoItem=" +
          this.params.tipoItem +
          "&proveedores=" +
          this.params.proveedores +
          "&tipo=" +
          this.params.tipo +
          "&search=" +
          form.search
      );
    },
    seleccionar: function(currentItem) {
      this.$emit("selected", currentItem);
    },
    crear: function() {
      this.$modal.show("item");
    },
    createdItem: function(item) {
      this.$refs.listaItems.actualizarLista(item);
      this.$modal.hide("item");
      this.seleccionar(item);
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/items/ListaItem.vue